module.exports = __webpack_public_path__ + "static/media/roberto-cavalli-uomo-big.af6c5223.png";